export const verifyUserString = (username) => {
  username = username.charAt(0) === "@" ? username : "@" + username;
  username = username.toLowerCase();
  const re = /^@[a-z0-9.-]{3,16}$/;
  return { passed: re.test(username), username: username };
};

export default verifyUserString;
